import {
  AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DefaultLangChangeEvent, TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/app/services/event.service';
import { Location } from '@angular/common';
import { languages } from 'src/app/shared/constants/app-enums';
import { ActivatedRoute, Router } from '@angular/router';
import { WalletConnectService } from 'src/app/services/wallet-connect.service';
import { selectedLang } from 'src/app/app.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {

  @Input() bgColor!: string;
  @Input() isHide!: boolean;


  @ViewChild('navigation') navigation!: ElementRef;
  languages = languages;
  hashKey: string = '';
  isMobile =
    (window.matchMedia &&
      window.matchMedia('(max-device-width: 1024px)').matches) ||
    screen.width <= 1024;
  currentLanguage: any;
  languagesList: Array<any> = languages;
  selectedLanguage: any;
  topOffset: number = 100;
  topPadding: any;
  elementRef: any;
  activeSectionIndex: number = -1;
  newLang: any;
  flag: any;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile =
      (window.matchMedia &&
        window.matchMedia('(max-device-width: 1024px)').matches) ||
      event.target.innerWidth <= 1024;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.setActiveSection();
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      document
        .getElementsByClassName('header-wrap')[0]
        .classList.add('scrolled');
    } else {
      document
        .getElementsByClassName('header-wrap')[0]
        .classList.remove('scrolled');
    }
  }

  name = 'Angular';

  navigations: { routeName: string; navName: string; navLink: string; targetBlank?: boolean }[] = [
    {
      routeName: 'feature',
      navName: 'nav_features',
      navLink: '',
    },

    // {
    //   routeName: 'chatbot',
    //   navName: 'nav_bestbot',
    //   navLink: '',
    // },
    // {
    //   routeName: 'crypto-wrapper',
    //   navName: 'nav_token',
    //   navLink: '',
    // },
    {
      routeName: 'roadmap',
      navName: 'nav_roadmap',
      navLink: '',
    },
    {
      routeName: 'best-token-airdrop',
      navName: 'nav_airdrop',
      navLink: '',
      // navLink: '',
    },

    // {
    //   routeName: 'faq',
    //   navName: 'nav_faqs',
    //   navLink: '',
    // },
    // {
    //   routeName: 'partner',
    //   navName: 'nav_partner',
    //   navLink: 'partner',
    // },
    // {
    //   routeName: 'BEST DEX',
    //   navName: 'nav_bestdex',
    //   navLink: 'https://bestdex.com',
    //   targetBlank: true
    // },
  ];

  constructor(
    private modalService: NgbModal,
    private location: Location,
    private router: Router,
    private eventService: EventService,
    private translate: TranslateService,
    private walletConnectService: WalletConnectService
  ) {

    this.newLang = this.eventService.getNewLang();

    console.log('newLAnguage=', this.newLang);
    if (this.newLang) {
      this.currentLanguage = this.newLang || "en";
      this.eventService.selectedLanguage = this.currentLanguage;
      this.selectedLanguage = this.languagesList.filter(
        (x) => x.value === this.currentLanguage
      )[0];
      this.flag = this.selectedLanguage.flag;
    }
    else {
      this.eventService.getLang().subscribe((val: any) => {
        this.currentLanguage = val || 'en';
        this.selectedLanguage = this.languagesList.filter(
          (x) => x.value === this.currentLanguage
        )[0];
      });
      this.flag = this.selectedLanguage.flag;

    }
  }

  ngOnInit(): void {
    this.translate.setDefaultLang(this.eventService.selectedLanguage);
    this.translate.use(this.eventService.selectedLanguage);
    this.eventService.setLang(this.eventService.selectedLanguage);
    if (!this.currentLanguage) {
      this.currentLanguage = selectedLang;
      this.selectedLanguage = this.languagesList.filter(
        (x) => x.value === this.currentLanguage
      )[0];
    }
    const sections = document.querySelectorAll('section');
  }

  ngAfterViewInit(): void {
    // if(window.location.hash) {
    //   setTimeout(() => {
    //     this.hashKey = window.location.hash.substring(200, window.location.hash.length);
    //     this.navigateToSection(this.hashKey);
    //     this.addActive(this.navigation.nativeElement);
    //   }, 500);
    // }
    if (window.location.hash) {
      setTimeout(() => {
        this.hashKey = window.location.hash;
        this.navigateToSection(this.hashKey);
        this.addActive(this.navigation.nativeElement);
      }, 500);
    }
  }

  openSidebar(content: any) {
    this.modalService.open(content, { modalDialogClass: 'dark-modal' });
  }

  navigateToSection(section: string) {
    this.hashKey = section;
    // let url = '/';
    // if (!this.router.url.endsWith('/')) {
    //   url += this.currentLanguage;
    // }
    // window.location.pathname = url;
    // this.router.navigate([url]);
    // window.location.reload();

    // if (section) {


    window.location.pathname = '/' + this.currentLanguage;
    window.location.hash = section;
    // setTimeout(() => {
    //   this.modalService.dismissAll();
    // },700);
    // }
  }

  addActive(event: any, modalClose: boolean = false) {
    const target: any = event.currentTarget ? event.currentTarget : event;
    let linkList = target.parentNode.parentNode.querySelectorAll('a');

    linkList.forEach((link: any) => {
      if (link === event.target || link.title === this.hashKey) {
        link.parentNode.classList.add('active');
      } else {
        link.parentNode.classList.remove('active');
      }
    });
    setTimeout(() => this.modalService.dismissAll(), 680);
  }

  changeLanguage(requestLang: any, flag: any): void {
    this.flag = flag;
    // this.selectedLanguage.flag = flag;
    // this.selectedLanguage = requestLang;
    this.eventService.selectedLanguage = requestLang;
    this.translate.use(this.eventService.selectedLanguage);
    this.eventService.setLang(this.eventService.selectedLanguage);
    this.eventService.currentLanguage = this.languages.filter(
      (x) => x.value === this.eventService.selectedLanguage
    )[0];
    this.currentLanguage = requestLang;
    this.replaceURL();
  }

  // replaceURL(): void {
  //   let C_url = this.router.url;
  //   const current_url = this.location.path().split('/');
  //   current_url.shift();
  //   if ((C_url == "/partner") || (C_url == "/airdrop")) {
  //     current_url.splice(1, 1, this.currentLanguage);
  //   }
  //   else {
  //     current_url.splice(0, 1, this.currentLanguage);
  //   }
  //   const new_url = current_url.join('/');
  //   window.location.hash = this.hashKey;
  //   console.log("newUrl==", new_url)
  //   this.location.replaceState('/' + new_url + this.hashKey);
  // }


  // replaceURL(): void {
  //   const current_url = this.router.url.split('/').filter(Boolean);
  //   if (current_url[0] === 'partner' || current_url[0] === 'airdrop') {
  //     current_url[1] = this.currentLanguage;
  //   } else {
  //     current_url[0] = this.currentLanguage;
  //   }
  //   const new_url = '/' + current_url.join('/') + this.hashKey;
  //   this.router.navigateByUrl(new_url, { replaceUrl: true });
  // }

  replaceURL(): void {
    const currentUrl = this.router.url; // Get the current URL, including query parameters
    const pathSegments = currentUrl.split('/');

    // Check if the current route is 'partner' or 'airdrop'
    if (pathSegments[1] === 'partner' || pathSegments[1] === 'airdrop') {
      // Update the language in the URL
      pathSegments[2] = this.currentLanguage;
    } else {
      // For other routes, update the language as the first segment
      pathSegments[1] = this.currentLanguage;
    }

    // Reconstruct the URL with the modified path and hashKey
    const newUrl = '/' + pathSegments.join('/') + this.hashKey;

    // Use Angular Router to navigate to the new URL
    this.router.navigateByUrl(newUrl, { replaceUrl: false });
  }

  // get currentLanguage() {
  //   return this.eventService.currentLanguage;
  // }

  get walletAddress(): any {
    return this.walletConnectService.walletAddress;
  }

  setActiveSection() {
    const scrollPosition = window.screenY;
    for (let i = 0; i < this.navigations.length; i++) {
      const section = this.navigations[i];
      const element = document.getElementById(section.routeName);
      if (element) {
        const rect = element.getBoundingClientRect();
        // console.log("rect===========",rect);
        if (
          scrollPosition >= rect.top - 10 &&
          scrollPosition < rect.bottom - 100
        ) {
          this.activeSectionIndex = i;
          // console.log("i===========",this.activeSectionIndex);
          break;
        }
      }
    }
  }

  isActiveSection(index: number): boolean {
    return index === this.activeSectionIndex;
    // return this.activeSections[index].some((isActive) => isActive);
  }

  disconnect(): void {
    this.walletConnectService.disConnectWallet();
  }

  scrollTop() {
    window.scrollTo(0, 140);
  }


  isRotated: boolean = false;

  toggleRotation(rotate: any) {
    if (rotate) {
      this.isRotated = !this.isRotated;
    }
    else {
      this.isRotated = false;
    }
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    // Check if the click event occurred outside of the icon
    const target = event.target as HTMLElement;
    const isIconClicked = target.closest('.dropdown');
    if (!isIconClicked) {
      // Reset the rotation when clicked outside
      this.isRotated = false;
    }
  }

}
